var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login"},[_vm._m(0),_c('div',{staticClass:"author-middle"},[_c('div',{staticClass:"middle-box"},[_c('p'),_c('login')],1)]),_c('div',{staticClass:"author-bottom"}),_c('input',{attrs:{"id":"userType","type":"hidden","value":"1"}})])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"author-top"},[_c('p',[_vm._v("河北《教育实践与研究》杂志社")]),_c('span',[_vm._v("作者端")])])
}]

export { render, staticRenderFns }